import React from 'react'
import { Route } from 'react-router-dom'
import AdminNav from '../Pages/Admin/AdminNav'
import NoMatch from '../Pages/NoMatch/NoMatch'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../entity/user/model/selector/getUserData/getUserData'

const AdminRoute = ({ component: Component, ...rest }) => {
  const user = useSelector(getUserData, shallowEqual)

  return (
    <Route
      {...rest}
      render={props =>
        user?.role === 'admin' ? (
          <>
            <AdminNav />
            <div className='dashboard-component'>
              <Component {...props} />
            </div>
          </>
        ) : (
          <NoMatch />
        )
      }
    />
  )
}

export default AdminRoute
